module.exports = __webpack_public_path__ + "fonts/montserrat-light.02afb26.ttf";